import React from "react";
import KmContent from "./km-content.jsx";
import DispatchContent from "./dispatch-content.jsx";
import BoContent from "./bo-content.jsx";
import EncounterContent from "./encounter-content.jsx";
import MaterialCautionContent from "./material-caution-content.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const GarrisonContent = ({ garrisonData, inspector, updatedUser, boName, showDetails }) => {
    const navigate = navigateHook();
    if (!garrisonData) return null;

    return (
        <tr>
            <td colSpan={12} className={'bg-white text-left'}>
                <table>
                    <tbody>
                        {garrisonData.map((garrison, index) => {
                            const period = garrison?.garrison_start + (garrison?.garrison_end ? ` até ${garrison?.garrison_end}` : '');
                            const url = `/despacho/garrison/form/${garrison?.garrisonid}`;
                            let authorInfo = null;

                            if (updatedUser?.length > 0) {
                                const user = updatedUser[0];
                                if (user?.owner && user?.time) {
                                    const date = new Date(user.time.replace(' ', 'T'));
                                    authorInfo = `${user.owner} em ${date.toLocaleDateString('pt-BR')} às ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
                                }
                            }

                            return (
                                <React.Fragment key={index}>

                                    {index === 0 && (
                                        <>
                                            <tr>
                                                <th className={'journal-label'}>Cadastrado por:</th>
                                                <td>{inspector || 'Não informado'}</td>

                                                {authorInfo && (
                                                    <>
                                                        <th className={'journal-label'}>Editado por:</th>
                                                        <td className={'transform -translate-x-[15px]'}>{authorInfo}</td>
                                                    </>
                                                )}
                                            </tr>

                                            <tr><td colSpan={12} className="author-divisor"></td></tr>
                                        </>
                                    )}

                                    <tr>
                                        <th className={'journal-label'}>Período:</th>
                                        <td className={'transform -translate-x-[55px] w-[432px]'}><a onClick={() => navigate(url, true)} className={'inner-link'}>{period}</a></td>

                                        <th className={'journal-label'}>Setor:</th>
                                        <td className={'table-break-word transform -translate-x-[65px] w-[432px]'}>{garrison?.sectors || 'Não informado'}</td>
                                    </tr>

                                    <tr>
                                        <th className={'journal-label'}>Equipe:</th>
                                        <td className={'table-break-word transform -translate-x-[60px] w-[432px]'}>{garrison?.garrison_team || 'Não informado'}</td>

                                        <th className={'journal-label'}>Contingentes:</th>
                                        <td className={'table-break-word transform -translate-x-[15px] w-[432px]'}>{garrison?.integrants || 'Não informado'}</td>
                                    </tr>

                                    <tr>
                                        <th className={'journal-label'}>Guarnição:</th>
                                        <td className={'table-break-word transform -translate-x-[40px] w-[432px]'}>{garrison?.garrison_name || 'Não informado'}</td>

                                        <th className={'journal-label'}>Animais:</th>
                                        <td className={'table-break-word transform -translate-x-[45px] w-[432px]'}>{garrison?.animals || 'Não informado'}</td>
                                    </tr>

                                    <KmContent garrison={garrison}/>

                                    <tr className="boxReadjust">
                                        <td colSpan={4}>
                                            <div className={"flex gap-3 mb-[30px]"}>
                                                <div className="obs-wrapper w-[50%]">
                                                    <div className="obs-title"><span>Observação inicial</span></div>
                                                    <div className="obs-box h-full">{garrison?.garrison_initialobservation}</div>
                                                </div>

                                                <div className="obs-wrapper w-[50%]">
                                                    <div className="obs-title"><span>Observação da guarnição</span></div>
                                                    <div className="obs-box h-full">{garrison?.observation}</div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <DispatchContent garrison={garrison} showDetails={showDetails}/>
                                    <BoContent garrison={garrison} boName={boName} showDetails={showDetails}/>
                                    <EncounterContent garrison={garrison} boName={boName} showDetails={showDetails}/>
                                    <MaterialCautionContent garrison={garrison} showDetails={showDetails}/>

                                    <tr><td colSpan={12} className="journal-divisor"></td></tr>

                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default GarrisonContent;
